import React from 'react';
import './Categories.css';
import ring from '../../assets/Images/Rings/ring2.webp';
import earring from '../../assets/Images/Earrings/earring3.webp';
import necklace from '../../assets/Images/Necklace/necklace.webp';
import pendant from '../../assets/Images/Pendant/pendant2.webp';
import diamond from '../../assets/Images/Diamond/diamond4.webp';
import gemstone from '../../assets/Images/Gemstone/gemstone2.webp';
import bracelet from '../../assets/Images/Bracelet/bracelet.webp';

const Categories = () => {
    // Sample category data
    const categories = [
      { title: "Rings", image: ring, description: "Classic and elegant rings for all occasions." },
      { title: "Earrings", image: earring, description: "Elegant earrings for a touch of sophistication and charm." },
      { title: "Necklaces", image: necklace, description: "Beautiful necklaces that perfectly complete your look." },
      { title: "Bracelet", image: bracelet, description: "Stylish bracelets that make every wrist shine." },
      { title: "Pendants", image: pendant, description: "Elegant pendants to reflect your personal style." },
      { title: "Diamond", image: diamond, description: "A diverse collection of natural diamonds, from classic white to rare fancy colors." },
      { title: "Gem Stone", image: gemstone, description: "Vibrant gemstones ranging from precious to semi-precious, tailored to your desires." },
    ];
  
    return (
      <div className="categories-container" id="categories">
        {/* Title Section */}
        <h1 className="categories-title">Categories</h1>
        
        {/* Description Section */}
        <p className="categories-description">
          From classic and timeless designs to modern and contemporary styles, our collection offers something for every taste and preference.
        </p>
  
        {/* Cards Section */}
        <div className="categories-cards-container">
          {categories.map((category, index) => (
            <div className="category-card" key={index}>
              <img src={category.image} alt={category.title} loading="lazy" />
              <h3>{category.title}</h3>
              <p>{category.description}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default Categories;
